import { defineStore } from "pinia";
import recursivelyLowercaseJSONKeys from "recursive-lowercase-json";
import { getRecommendedProducts } from "@/pages/product_card/api/product.api";
import { objectByString } from "@/pages/product_card/tools/object";

export const useRecommendedStore = defineStore("recommended", {
  state: () => {
    return {
      products: {},
      product: {
        id: "",
        name: "",
        code: "",
        media: {},
        props: {
          brand: {},
          model: {},
          sex: {},
          ncode: {},
        },
        documents: {},
        features: {},
        offers: {},
        section: {},
        sizeMap: {},
        sizeTable: {},
        selected: false,
      },
    };
  },
  actions: {
    async getRecommendedProducts(productCode) {
      this.products = recursivelyLowercaseJSONKeys(
        await getRecommendedProducts(productCode)
      );
    },
    getProductPicture(product) {
      const matchedMedia = Object.fromEntries(
        Object.entries(product.media).filter(([, item]) => {
          return item.type === "main";
        })
      );

      let media = {};
      if (Object.values(matchedMedia).length > 0) {
        media = Object.values(matchedMedia);
        return objectByString(media[0], "sizes.default");
      } else {
        return media;
      }
    },
  },
  getters: {
    getSliderItems(state) {
      console.log(state.products);
      return state.products;
    },
  },
});
